<template>
    <PartTransfer></PartTransfer>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const PartTransfer = defineAsyncComponent(() =>
    import("../../components/Logistics/SupplyChain/Dashboard.vue")
);
export default {
    name: "Logistics_PartTransfer", //The name you are in should not equal the name of the component you are importing.
    components: { PartTransfer, AuthLayout },
};
</script>
